export default __webpack_public_path__ + "static/media/Card-GemVisa.111b4178.png";